<script>
    import QuestionLibrary from '../../Models/QuestionLibraryModel';
    import Loader from '../Loader.svelte';
    import {addFormModal} from '../../Forms/ModalFormManager.svelte';
    import {notifier} from '@beyonk/svelte-notifications';
    import {confirm} from '../Confirmation.svelte';
    import {forms} from '../../lib/forms';
    import Collapse from '../Collapse.svelte';
    import {showContextMenu} from '../ContextMenu.svelte';
    import LibraryControl from './LibraryControl.svelte';
    import SortableList from '../SortableList.svelte';
    import {replace} from 'svelte-spa-router'
    import parseCSV from '../../lib/csv';

    export let params;
    let questionLibrary;

    function addCategory() {
        addFormModal({
            title: "Add Category",
            fields: forms['category']
        }).then((category) => {
           $questionLibrary.categories.addChild(category);
        }).catch()
    }

    function editCategory(category) {
        addFormModal({
            title: "Edit Category",
            fields: forms['category'],
            data: category.details
        }).then(data => {
            category.save(data).then(() => {
                notifier.success("Category Saved");
            }).catch(err => {
                notifier.danger(err)
            })
        }).catch(() => null)
    }

    async function deleteCategory (category) {
        try {
            await confirm(`Are you sure you want to delete ${category.details.name}?`)
        } catch (e) {
            return;
        }
        await category.delete();

        notifier.success("Category Deleted")
    }

    function handleCategoryMenu(evt, category) {
        showContextMenu(evt.clientX, evt.clientY, [
            {
                name: "Edit Category",
                action: () => editCategory(category)
            },
            {
                name: "Delete Category",
                action: () => deleteCategory(category)
            }
        ]);
    }


    function addSubcategory(category) {
        addFormModal({
            title: "Add Subcategory",
            fields: forms['subcategory']
        }).then((subcategory) => {
            category.subcategories.addChild(subcategory);
        }).catch()
    }

    function editSubcategory(subcategory) {
        addFormModal({
            title: "Edit Category",
            fields: forms['subcategory'],
            data: subcategory.details
        }).then(data => {
            subcategory.save(data).then(() => {
                notifier.success("Subcategory Saved");
            }).catch(err => {
                notifier.danger(err)
            })
        }).catch(() => null)
    }

    function deleteSubcategory(subcategory) {
        confirm(`Are you sure you wish to delete the subcategory "${subcategory.details.name}"?`).then(() => {
            subcategory.delete().then(() => {
                notifier.success("Subcategory Deleted");
            }).catch(err => {
                notifier.danger(err);
            });
        }).catch(() => null);
    }

    function handleSubcategoryMenu(evt, subcategory) {
        showContextMenu(evt.clientX, evt.clientY, [
            {
                name: "Edit Subcategory",
                action: () => editSubcategory(subcategory)
            },
            {
                name: "Delete Subcategory",
                action: () => deleteSubcategory(subcategory)
            }
        ]);
    }

    function addControl(subcategory) {
        addFormModal({
            title: "Add Control",
            fields: forms['control']
        }).then((control) => {
            subcategory.controls.addChild(control).then( () => {
                notifier.success("Contrl Created");
            })
        }).catch()
    }

    function handleControlMenu(evt, control) {
        showContextMenu(evt.clientX, evt.clientY, [
            {
                name: "Delete Control",
                action: () => deleteControl(control)
            }
        ])
    }

    function deleteControl(control) {
        confirm(`Are you sure you wish to delete the control "${control.details.name}"?`).then(() => {
            let control_id = control.details._id;

            control.delete().then(() => {
                notifier.success("Control Deleted")
            });

            if (control_id == params.control_id) {
                replace(`/questionLibrary/${$questionLibrary.id}/`)
            }
        }).catch(() => null);
    }

    function handleDrop(sc, evt) {
        if (evt.newIndex == evt.oldIndex) return;

        let controls = [...sc.controls];
        let after, before;
        if (evt.newIndex == 0) {
            before = controls[evt.newIndex + 1];
        } else if (evt.newIndex == controls.length - 1) {
            after = controls[evt.newIndex]
        } else {
            if (evt.newIndex < evt.oldIndex) {
                after = controls[evt.newIndex - 1];
                before = controls[evt.newIndex];
            } else {
                after = controls[evt.newIndex];
                before = controls[evt.newIndex + 1]
            }
        }

        sc.controls.moveChild(controls[evt.oldIndex], after, before);
    }

    function importFile() {
        addFormModal({
            title: "Import Question Library",
            fields: [{
                name: 'import_file',
                type: 'file'
            }]
        }).then(async data => {
            console.log(data);
            let import_data = data['import_file'];

            const csv = parseCSV(await import_data[0].text());
            QuestionLibrary.importQuestionLibrary($questionLibrary, csv);
        })
    }

    function loadData(library_id) {
        if (!$questionLibrary || library_id != $questionLibrary.id) {
            questionLibrary = QuestionLibrary.getStore(library_id)
        }
    }

    $: loadData(params.id);
    $: console.log($questionLibrary);
</script>

<Loader loading={!$questionLibrary}>
    <div class="container viewport is-fluid">
        <div class="columns viewport">
            <div class="column is-3">
                <h1 class="title is-1">
                    {$questionLibrary.details.name}
                    <button
                        class="button is-pulled-right"
                        on:click={addCategory}
                    >
                        Add Category
                    </button>
                </h1>
                <button class="button" on:click={importFile}>Import</button>

                <aside class="menu">
                    <ul class="menu-list">
                        {#each [...$questionLibrary.categories] as category (category.id)}
                        <li>
                            <Collapse title_level="5" collapsed={false}>
                                <span slot="title" on:contextmenu|preventDefault={(evt) => handleCategoryMenu(evt, category)}>
                                    {category.details.control_number} {category.details.name}
                                    <span
                                        class="button is-small is-pulled-right"
                                        on:click|preventDefault|stopPropagation={addSubcategory(category)}
                                    >
                                        Add SubCategory
                                    </span>
                                </span>
                                <ul>
                                    {#each [...category.subcategories] as subcategory (subcategory.id)}
                                    <li>
                                        <Collapse title_level="6" collapsed={false}>
                                            <span slot="title" on:contextmenu|preventDefault={(evt) => handleSubcategoryMenu(evt, subcategory)}>
                                                {subcategory.details.control_number} {subcategory.details.name}
                                                <span
                                                    class="button is-small is-pulled-right"
                                                    on:click|preventDefault|stopPropagation={addControl(subcategory)}
                                                >
                                                    Add Control
                                                </span>
                                            </span>
                                            <SortableList items={[...subcategory.controls]} let:item={control} on:end={(evt) => handleDrop(subcategory, evt.detail)}>
                                                    <a class="pointer menu-item"
                                                        on:contextmenu|preventDefault={(evt) => handleControlMenu(evt, control)}
                                                        href="#/questionLibrary/{params.id}/{control.id}"
                                                        class:is-active={params.control_id == control.id}
                                                    >
                                                        <strong>{control.details.control_number}</strong> {control.details.name}
                                                    </a>
                                            </SortableList>
                                        </Collapse>
                                    </li>
                                    {/each}
                                </ul>

                            </Collapse>
                        </li>
                    {/each}
                    </ul>
            </div>
            <div class="column">
                {#if params.control_id}
                    <LibraryControl control_id={params.control_id} />
                {/if}
            </div>
        </div>
    </div>

</Loader>

<style>
    ul.menu-list :global(.title) {
        display: inline-block;
        width: 100%;
    }

    .button.is-small {
        margin-top: -5px;
    }

    .column {
        overflow: auto;
        display: flex;
        flex-direction: column;
    }
</style>